import { render, staticRenderFns } from "./QuestionCommentHolder.vue?vue&type=template&id=2cd6c60c"
import script from "./QuestionCommentHolder.vue?vue&type=script&lang=js"
export * from "./QuestionCommentHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports